import React, { useRef, useState } from "react";
import { LogoRound } from "../ui/Logo";
import { SpacingHeight } from "../ui/Spacing";
import Center from "../ui/Center";
import { ButtonSingle } from "./Button";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import { ResponsiveDeviceType } from "../../layouts/ScreenMedia";
import { TextBlock } from "../ui/Text";

interface ImagePickerInterface {
  getPreview: (preview: string | null, fileDetail: File | null) => void;
  children?: React.ReactNode;
  size?: number;
  type?: number;
}

const ImagePickerPreview: React.FC<ImagePickerInterface> = ({
  getPreview,
  children,
  size = 100,
  type,
}) => {
  type = type ?? ResponsiveDeviceType();
  const inputRef = useRef<HTMLInputElement>(null);
  const [file, setFile] = useState<File | null>(null);
  const [preview, setPreview] = useState<string | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0] ?? null;
    setFile(selectedFile);

    if (selectedFile) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result as string);
        getPreview(reader.result as string, selectedFile);
      };
      reader.readAsDataURL(selectedFile);
    } else {
      setPreview(null);
      getPreview(null, null);
    }
  };

  const handleClick = () => {
    inputRef.current?.click(); // programmatically trigger click
  };

  return (
    <div className="text-center">
      <input
        type="file"
        ref={inputRef}
        accept="image/*"
        onChange={handleFileChange}
        className="invisible file-input"
      />
      {/* {file && <p>Selected file: {file.name}</p>}
      {preview && <img src={preview} alt="preview" width={200} />} */}
      <Center>
        {file ? <LogoRound url={preview} name="" size={size} /> : children}
      </Center>
      <SpacingHeight value={type === 1 ? 21 : 26} />
      <Center>
        <ButtonSingle handleClick={handleClick} width={100} height={35}>
          {AppTranslation.text(file ? "change" : "upload")}
        </ButtonSingle>
      </Center>
      <SpacingHeight value={type === 2 ? 16 : 14} />
      <TextBlock
        textColor="theme-sublabel"
        fontSize="13_14"
        fontName="book"
        center={true}
      >
        {AppTranslation.text("format_file_image2").replaceAll("\n", "<br />")}
      </TextBlock>
    </div>
  );
};

export default ImagePickerPreview;
